<template>
  <div class="log-detail-container">
    <div class="file-info-container">
      <div class="file-content file-page-container">
        <img v-if="log.isImg&&isExist" ref="image" class="file-image" :src="log.url" fit="contain" />
        <img v-else-if="log.isImg&&!isExist" ref="image" class="file-image" src="https://front-xps-cdn.xsyx.xyz/custom/xps/images/delete.png" fit="contain" title='图片CDN缓存已失效！文件已彻底删除！' />
        <div v-else class="file-image file-icon" :class="`file-icon-${log.ext}`" :title="isExist?'':'文件CDN缓存已失效！文件已彻底删除！'"> </div>
      </div>
      <div class="file-info">
        <div class="info-item"><label for="">文件名称：</label><span>{{log.fileName}}</span></div>
        <div class="info-item"><label for="">上传时间：</label><span>{{formatTime(log.uploadTime)}}</span></div>
        <div class="info-item"><label for="">删除时间：</label><span>{{formatTime(log.createTime)}}</span></div>
        <div class="info-item"><label for="">文件地址：</label><span class="url" v-clipboard:copy="log.url" v-clipboard:success="onCopy">{{log.url}}</span></div>
      </div>
    </div>
    <p>上传&删除用户信息</p>
    <div class="user-info-container">
      <div class="user-info-collapse">
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <img class="avatar" :src="log.uploadUser.avatar" alt="">
              <span class="name">{{log.uploadUser.realName}}（{{log.uploadUser.userName}}）</span>
            </template>
            <div class="collapse-expand">
              <div class="item">部门：{{log.uploadUser.dept}}</div>
              <div class="item">电话：{{log.uploadUser.mobile}}</div>
              <div class="item">邮箱：{{log.uploadUser.email}}</div>
              <div class="item">角色：{{log.uploadUser.isAdmin?'管理员':'普通用户'}}</div>
            </div>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <img class="avatar" :src="log.operator.avatar" alt="">
              <span class="name">{{log.operator.realName}}（{{log.operator.userName}}）</span>
            </template>
            <div class="collapse-expand">
              <div class="item">部门：{{log.operator.dept}}</div>
              <div class="item">电话：{{log.operator.mobile}}</div>
              <div class="item">邮箱：{{log.operator.email}}</div>
              <div class="item">角色：{{log.operator.isAdmin?'管理员':'普通用户'}}</div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="more-operation-container">
        <el-button :disabled="!isExist" @click="checkCosExist" title="检查COS文件是否存在，是重新上传该文件的第一步操作！">检查COS是否存在文件</el-button>
        <el-button :disabled="!isExist||isCosExist" @click="uploadFileAgain" title="文件CDN资源存在和检查COS文件不存在之后方可重新上传！">重新上传该文件</el-button>
        <el-button @click="closeDialog">关闭弹窗</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';
import { deleteApi, xpsApi } from '@/api/index';
export default {
  name: 'delete-log-detail',
  props: {
    log: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      isExist: false, //判断CDN资源是否存在
      isCosExist: true,//判断COS资源是否存在
      file: '',// 文件对象
      path: ''//文件上传路径
    }
  },
  mounted () {
    // 检查文件是否存在
    this.checkFileExist();
  },
  methods: {
    // 关闭弹窗
    closeDialog () {
      this.$emit('close');
    },
    // 重新上传文件
    async uploadFileAgain () {
      // 上传服务器
      const form = new FormData();
      // 文件对象
      form.append("file_data", this.file);
      form.append("path", this.path);
      let data = await xpsApi.uploadCos(form);
      if (data) {
        this.isCosExist = true;
        return this.$message.success('文件上传成功！');
      } else {
        return this.$message.error('文件上传出错啦！！');
      }
    },
    // 修改文件删除日志状态 文件已经彻底删除
    async fileThroughtDelete () {
      const res = await deleteApi.fileThroughtDelete({ id: this.log.id });
      if (res.code !== 200) {
        this.$message.error(res.message);
      }
    },
    // 检查COS是否存在该文件
    async checkCosExist () {
      let fPathArr = this.log.url.split('https://front-xps-cdn.xsyx.xyz/');
      if (fPathArr.length <= 1) {
        fPathArr = this.log.url.split('https://uat-xps-cdn.xsyx.xyz/')
      }
      const path = fPathArr[1];
      const res = await xpsApi.doesFileExist({ path });
      if (res.code === '404') {
        this.isCosExist = false;
        this.$message.success('COS文件不存在，您可以点击重新上传按钮，重新上传该文件！');
      } else {
        this.$message.warning('COS文件存在！无法重新上传！');
        this.isCosExist = true;
      }
    },
    // 检查文件CDN资源是否有效
    async checkFileExist () {
      // 如果文件被彻底删除
      if (this.log.isReject) {
        this.isExist = false;
      } else {
        try {
          // 文件地址
          const url = this.log.url;
          // 请求文件对象 Blob
          const res = await axios.get(url, { responseType: 'blob' });
          if (res.status === 200) {
            // 获取content-type
            let type = res.headers['content-type'];
            // 创建blob对象
            let blob = new Blob([res.data], { type: `${type};charset=utf-8` });
            // 获取文件名称
            let fileName = decodeURI(url.substring(url.lastIndexOf('/') + 1));
            // 获取文件存储路径
            let fPathArr = url.split('https://front-xps-cdn.xsyx.xyz');
            if (fPathArr.length <= 1) {
              fPathArr = url.split('https://uat-xps-cdn.xsyx.xyz')
            }
            let path = fPathArr[1];
            this.path = path.substring(0, path.lastIndexOf('/') + 1);
            // 转换为file对象
            this.file = new File([blob], fileName, { type });
          }
          this.isExist = true;
        } catch (error) {
          this.isExist = false;
          this.fileThroughtDelete();
        }
      }
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
  }
}
</script>

<style lang="scss" scoped>
.log-detail-container {
  .file-info-container {
    display: flex;
    flex-flow: row nowrap;
    .file-content {
      .file-image {
        width: 150px;
        max-height: 150px;
        object-fit: contain;
        &.file-icon {
          background-size: contain;
        }
      }
    }
    .file-info {
      margin-left: 40px;
      display: flex;
      align-items: center;
      flex-flow: row wrap;
      .info-item {
        width: 100%;
        margin-top: 10px;
        .url {
          cursor: pointer;
          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }
  .user-info-container {
    width: 100%;
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
    .name {
      margin-left: 5px;
      font-size: 12px;
      color: #000;
    }
    .collapse-expand {
      display: flex;
      flex-flow: row wrap;
      .item {
        width: 50%;
      }
    }
  }
  .more-operation-container {
    margin-top: 20px;
    text-align: center;
  }
}
</style>